import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Layout from '../../components/Layout';
import { AppLoader } from '../AppLoader';
import { resetBodyScrollLock } from '../../hooks/useBodyScrollLock';

export interface AppShellProps {}

export const AppShell = (props: AppShellProps) => {
    const { pathname } = useLocation();
    useEffect(() => { resetBodyScrollLock(); }, [pathname]);

    return (
        <Layout>
            <Suspense fallback={<AppLoader />}>
                <Outlet />
            </Suspense>
        </Layout>
    );
};
